import { useEffect } from 'react';
import axios from 'axios';
import { conf } from '../confg';

const GOFTINO_MARK = 'data-goftino-injected';

function injectScriptHtml(html) {
  if (!html || typeof document === 'undefined') return;
  if (document.querySelector(`[${GOFTINO_MARK}]`)) return;

  const wrapper = document.createElement('div');
  wrapper.setAttribute(GOFTINO_MARK, '1');
  wrapper.style.display = 'none';
  wrapper.innerHTML = html;

  const nodes = Array.from(wrapper.childNodes);
  const hasScriptTag = wrapper.querySelector('script');

  if (!hasScriptTag && html.trim()) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = html;
    script.setAttribute(GOFTINO_MARK, '1');
    document.body.appendChild(script);
    return;
  }

  nodes.forEach((node) => {
    if (node.nodeName === 'SCRIPT') {
      const script = document.createElement('script');
      Array.from(node.attributes || []).forEach((attr) => {
        script.setAttribute(attr.name, attr.value);
      });
      if (node.src) {
        script.src = node.src;
      } else {
        script.text = node.textContent || '';
      }
      script.setAttribute(GOFTINO_MARK, '1');
      document.body.appendChild(script);
      return;
    }
    document.body.appendChild(node.cloneNode(true));
  });
}

/**
 * Loads Goftino chat widget script from site-info when enabled in admin.
 */
const GoftinoWidget = () => {
  useEffect(() => {
    let cancelled = false;
    axios({ url: conf.server_url + 'site-info', method: 'GET' })
      .then((res) => {
        if (cancelled) return;
        const goftino = res?.data?.data?.goftino;
        if (goftino?.enabled && goftino?.script) {
          injectScriptHtml(goftino.script);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default GoftinoWidget;
